// PermissionsContextDef needs to have DataPlatformApi imported
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { DataPlatformApi } from '@kcftech/data-platform-sdk';
import { PermissionsContext } from 'contexts/PermissionsContext';
import { createContext } from 'react';

// this is here to make vite HMR behave
// https://github.com/vitejs/vite/issues/3301
export const PermissionsContextDef = createContext<PermissionsContext | null>(null);
